<template>
  <div class="home">
    <h1>All Customers</h1>
    <div class="loader-container">
      <div>
        <datepicker
          :typeable="true"
          v-model="startDate"
          @input="getCustomerData"
          :monday-first="true"
        >
        </datepicker>
        -
        <datepicker
          :typeable="true"
          v-model="endDate"
          @input="getCustomerData"
          :monday-first="true"
        >
        </datepicker>
      </div>
      <div v-if="customerData">
        <div class="customer-data">
          <div class="customer-data-label">Items</div>
          <div class="customer-data-value">{{ customerData.itemCount }}</div>
        </div>
        <div class="customer-data">
          <div class="customer-data-label">Orders</div>
          <div class="customer-data-value">{{ customerData.orderCount }}</div>
        </div>
        <div class="customer-data">
          <div class="customer-data-label">Value</div>
          <div class="customer-data-value customer-data-total-value">
            {{ totalValue }}
          </div>
        </div>
        <div class="customer-data">
          <div class="customer-data-label">New Users</div>
          <div class="customer-data-value">{{ customerData.userCount }}</div>
        </div>
        <div class="actions">
          <button @click.prevent="getCustomerData">Refresh</button>
        </div>
      </div>
      <Loader :loading="loadingCustomerData" />
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import service from "@/services/service.js";
import Datepicker from "vuejs-datepicker";

export default {
  components: { Loader, Datepicker },
  data() {
    return {
      customerData: null,
      startDate: new Date().setFullYear(new Date().getFullYear() - 1),
      endDate: new Date(),
      loadingCustomerData: false
    };
  },
  computed: {
    totalValue() {
      return new Intl.NumberFormat("en", {
        style: "currency",
        currency: this.getCurrency(),
        maximumFractionDigits: 0
      }).format(this.customerData.totalValue);
    }
  },
  created() {
    this.getCustomerData();
  },
  methods: {
    getCustomerData() {
      var self = this;
      self.loadingCustomerData = true;
      service
        .getCustomerData(
          this.formatDate(this.startDate),
          this.formatDate(this.endDate)
        )
        .then(response => {
          self.customerData = response.data[0];
          self.loadingCustomerData = false;
        })
        .catch(() => {
          self.loadingCustomerData = false;
        });
    }
  }
};
</script>
